module.exports = __webpack_public_path__ + "assets_app/img/key-start.430bbeb9.svg";